import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  CONTROLLER,
  MONITOR,
  RESULTS
} from '../routes'
import { useModule } from '@eggplant/routing'
import type { Props } from '../types'

interface Base {
  modelId?: string
}

interface WithTestCaseId extends Base {
  testCaseId?: string
  testCaseName?: never
  modelId?: string
  testStatus?: string
  startTime?: string
  endTime?: string
  assetId?: string
  monitorConfigId?: string
  sort?: string
  order?: '+' | '-'
  variance?: 'primary' | 'secondary'
}

interface WithTestCaseName extends Base {
  testCaseId?: never
  testCaseName?: string
  modelId?: string
  testStatus?: string
  startTime?: string
  endTime?: string
  assetId?: string
  monitorConfigId?: string
  sort?: string
  order?: '+' | '-'
  variance?: 'primary' | 'secondary'
}

type Params = WithTestCaseId | WithTestCaseName

const LinkToTestResults = ({
  children,
  modelId,
  testCaseName,
  testCaseId,
  testStatus,
  label,
  monitorConfigId,
  isHyperlink,
  startTime,
  endTime,
  assetId,
  sort,
  order,
  variance = 'primary'
}: Props & Params) => {
  const [isMonitorFlag] = useModule()

  const path = isMonitorFlag
    ? MONITOR
    : CONTROLLER

  const base = '/' + path + '/' + RESULTS

  const params = {
    model_id: modelId,
    testcase: testCaseName, // will be encoded
    test_case_ids: testCaseId,
    teststatus: testStatus,
    starttime: startTime,
    endtime: endTime,
    asset_id: assetId,
    sort,
    order
  }

  const monitorParam = {
    ...params,
    test_config_ids: monitorConfigId
  }

  return (
    <StyledLink
      aria-label={label}
      isHyperlink={isHyperlink}
      to={
        makeQueryString(
          base,
          isMonitorFlag
            ? monitorParam
            : params)
      }
      variance={variance}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToTestResults
